export type UserRoleName =
    'architect' |
    'commercial client' |
    'domestic client' |
    'builder' |
    'building inspector' |
    'area manager' |
    'plan check engineer' |
    'building inspector company' |
    'multi-displinary' |
    'quantity surveyor' |
    'engineer' |
    'employee'
    ;

export const getLoginUserRoleName = async (): Promise<UserRoleName | ''> => {
    try {
        const userTypeName = await Promise.resolve(localStorage.getItem('user_type_name'));
        const roleName = userTypeName ? userTypeName.toLowerCase() : '';

        const validRoles: UserRoleName[] =
            [
                'architect',
                'commercial client',
                'domestic client',
                'builder',
                'building inspector',
                'area manager',
                'plan check engineer',
                'building inspector company',
                'multi-displinary',
                'quantity surveyor',
                'engineer',
                'employee'
            ];
        return validRoles.includes(roleName as UserRoleName) ? (roleName as UserRoleName) : '';
    } catch (error) {
        return '';
    }
};

export const checkIsBuildingInspector = async (): Promise<boolean> => {
    const loginUserRoleName = await getLoginUserRoleName();

    if (!loginUserRoleName) return false;

    const inspectorRoles: UserRoleName[] = [
        'building inspector',
        'area manager',
        'building inspector company',
        'plan check engineer',
    ];

    return inspectorRoles.includes(loginUserRoleName);
};

export const checkIsArchitect = async (): Promise<boolean> => {
    const loginUserRoleName = await getLoginUserRoleName();

    if (!loginUserRoleName) return false;

    const architectRoles: UserRoleName[] = [
        'architect',
        'multi-displinary',
        'quantity surveyor',
        'engineer'
    ];

    return architectRoles.includes(loginUserRoleName);
};

export const checkIsClient = async (): Promise<boolean> => {
    const loginUserRoleName = await getLoginUserRoleName();

    if (!loginUserRoleName) return false;

    const clientRoles: UserRoleName[] = [
        'commercial client',
        'domestic client',
    ];

    return clientRoles.includes(loginUserRoleName);
};